import React from 'react';
import Container from '../../v2/Container';
import CustomerCart from '../../CustomerCart';

export default function Cart() {
  return (
    <Container padding={8}>
      <CustomerCart />
    </Container>
  );
}
